var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "changeOwnerModalRef",
      attrs: { id: "change-owner-modal", size: "sm", title: "Trocar titular" },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "form",
        {
          ref: "form",
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "2rem", width: "100%" } },
            [
              _c("SocialNumberInput", {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.socialNumber,
                  callback: function($$v) {
                    _vm.socialNumber = $$v
                  },
                  expression: "socialNumber"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }